module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('modal', [_c('h1', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.error ? 'Error' : 'Login'))]), _vm._v(" "), _c('div', {
    staticClass: "body",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.error) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.error))])]) : _c('table', [_c('tr', [_c('td', [_vm._v("User:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user),
      expression: "user"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter your username"
    },
    domProps: {
      "value": (_vm.user)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pasword:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Enter your password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.error) ? _c('a', {
    staticClass: "modal-default-button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v("\n      Ok\n    ")]) : [_c('a', {
    staticClass: "modal-default-button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._v("\n        Login\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "modal-default-button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v("\n        Cancel\n      ")])]], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56e742bf","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginModal.vue
// module id = 634
// module chunks = 2